export var version = '3.3.20';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/@apollo/client/version.js
// module id = 1979
// module chunks = 69